document.addEventListener('DOMContentLoaded', function() {
    closePopup();

    function adjustSlidesHeight(swiper) {
        const slides = swiper.el.querySelectorAll('.swiper-slide');
        let maxHeight = 0;

        if (window.innerWidth > 992) {
            // reset height
            slides.forEach(slide => {
                slide.style.height = 'auto';
                const h = slide.offsetHeight;
                if (h > maxHeight) maxHeight = h;
            });
        
            // apply the tallest height to all
            slides.forEach(slide => {
                slide.style.height = `${maxHeight}px`;
            });
        } else {
            return;
        }
    }

    function closePopup() {
        let popup = document.querySelector('.popup');

        if (popup) {
            const closeBtn = popup.querySelector('.close')
    
            closeBtn.addEventListener('click', function() {
                popup.classList.add('d-none');
            })
        }
    }

    function setSwiperContainerMinHeight(selector) {
        const container = document.querySelector(selector);
        if (!container) return;

        const slides = container.querySelectorAll('.swiper-slide');
        if (!slides.length) return;

        let maxHeight = 0;
        slides.forEach(slide => {
            const h = slide.offsetHeight;
            if (h > maxHeight) maxHeight = h;
        });

        let sumValue = () => {
            if (selector === '#ofertas') {
                return 836 - maxHeight;
            } else {
                return 53;
            }
        }
        const finalHeight = maxHeight + sumValue();
        container.style.minHeight = finalHeight + 'px';
    }

    ['#ofertas', '.release', '.most-sold', ].forEach(container => setSwiperContainerMinHeight(container));

    // swipers
    const swiperHero = new Swiper('.swiper-hero', {
        slidesPerView: 1,
        spaceBetween: 20,
        centeredSlides: true,
        loop: true,
        effect: 'coverflow',
        speed: 800,
    
        autoplay: {
            delay: 6000,
            disableOnInteraction: false,
        },
        coverflowEffect: {
            depth: 100,
            rotate: 0,
            stretch: -55,
            modifier: 1,
            slideShadows: false
        },
        pagination: {
            el: '.swiper-hero .swiper-pagination',
            clickable: true,
            // dynamicBullets: true,
        },
        breakpoints: {
            992: {
                slidesPerView: 1.18,
                spaceBetween: 80,
            }
        }
    })

    const swiperFilters = new Swiper('.swiper-filters', {
        slidesPerView: "auto",
        spaceBetween: 16,
        loop: false,
        speed: 800,
    
        navigation: {
            prevEl: '.filters .arrow-prev',
            nextEl: '.filters .arrow-next',
        },
        pagination: {
            el: '.swiper-filters .swiper-pagination',
            clickable: false,
        },
        breakpoints: {
            992: {
                slidesPerView: 3,
                spaceBetween: 32,
            },
            1200: {
                slidesPerView: 4,
            },
            1400: {
                slidesPerView: 5,
            }
        },
        on: {
            afterInit() {
                adjustSlidesHeight(this)
            },
            resize() {
                adjustSlidesHeight(this)
            }
        }
    })

    const swiperSales = new Swiper('.swiper-sales', {
        slidesPerView: "auto",
        spaceBetween: 35,
        loop: true,
        speed: 800,
    
        navigation: {
            prevEl: '.sales .arrow-prev',
            nextEl: '.sales .arrow-next',
        },
        breakpoints: {
            992: {
                slidesPerView: 5,
            }
        }
    })

    const swiperCta = new Swiper('.swiper-cta', {
        slidesPerView: 1,
        spaceBetween: 35,
        loop: true,
        speed: 800,

        pagination: {
            el: '.swiper-cta .swiper-pagination',
            clickable: false,
        },
    })

    const swiperRelease = new Swiper('.swiper-release', {
        slidesPerView: "auto",
        spaceBetween: 40,
        loop: true,
        speed: 800,
    
        navigation: {
            prevEl: '.release .arrow-prev',
            nextEl: '.release .arrow-next',
        }
    })

    const swiperMost = new Swiper('.swiper-most', {
        slidesPerView: "auto",
        spaceBetween: 40,
        loop: true,
        speed: 800,
    
        navigation: {
            prevEl: '.most-sold .arrow-prev-1',
            nextEl: '.most-sold .arrow-next-1',
        }
    })

    const swiperAbout = new Swiper('.swiper-about', {
        slidesPerView: 1,
        spaceBetween: 24,
        loop: true,
        speed: 800,

        autoplay: {
            delay: 6000,
            disableOnInteraction: false,
        },
        pagination: {
            el: '.swiper-about .swiper-pagination',
            clickable: false,
        }
    })

    const swiperClients = new Swiper('.swiper-clients', {
        slidesPerView: 1,
        spaceBetween: 48,
        loop: true,
        speed: 800,
        cssMode: true,

        autoplay: {
            delay: 3000,
            disableOnInteraction: true,
        },
        navigation: {
            prevEl: '.clients-section .arrow-prev',
            nextEl: '.clients-section .arrow-next',
        },
        breakpoints: {
            992: {
                slidesPerView: "auto"
            }
        }
    })
})